import React from 'react';
import { PenaltyInput } from './PenaltyInput';
import { t } from 'i18next';

interface PenaltyInputsProps {
  waterPenalties: number;
  obPenalties: number;
  dropPenalties: number;
  onWaterPenaltiesChange: (value: number) => void;
  onObPenaltiesChange: (value: number) => void;
  onDropPenaltiesChange: (value: number) => void;
}

const PenaltyInputs: React.FC<PenaltyInputsProps> = ({
  waterPenalties,
  obPenalties,
  dropPenalties,
  onWaterPenaltiesChange,
  onObPenaltiesChange,
  onDropPenaltiesChange
}) => {
  return (
    <>
      <h4>{t('penalties')}</h4>
      <div className="flex flex-row justify-between mb-4">
        <PenaltyInput
          label="Water"
          value={waterPenalties}
          onIncrease={() => onWaterPenaltiesChange(waterPenalties + 1)}
          onDecrease={() => onWaterPenaltiesChange(Math.max(0, waterPenalties - 1))}
          colorClass='text-blue-500'
        />
        <PenaltyInput
          label="OB"
          value={obPenalties}
          onIncrease={() => onObPenaltiesChange(obPenalties + 1)}
          onDecrease={() => onObPenaltiesChange(Math.max(0, obPenalties - 1))}
          colorClass='text-green-500'
        />
        <PenaltyInput
          label="Drop"
          value={dropPenalties}
          onIncrease={() => onDropPenaltiesChange(dropPenalties + 1)}
          onDecrease={() => onDropPenaltiesChange(Math.max(0, dropPenalties - 1))}
          colorClass='text-red-500'
        />
      </div>
    </>
  );
};

export default PenaltyInputs;
